import { useEffect } from "react";

import { Dialog, DialogBody } from "V2.0/common/dialog";

import { DialogTitleWithClose } from "V2.0/components/DialogTitleWithClose";

import { GlobeAltIcon } from "@heroicons/react/24/outline";

import useLivekitWebCall from "V2.0/HomePages/LivekitWebcall/useLivekitWebcall";
import { LivekitWebCall } from "V2.0/HomePages/LivekitWebcall";

export default function WebCall(props) {
  const { assistantId, assistantName, workspaceId, onClose } = props;
  const { room, onConnect } = useLivekitWebCall(workspaceId, assistantId);

  useEffect(() => {
    return () => {
      room.disconnect();
    };
  }, []);

  return (
    <Dialog
      size="lg"
      open={true}
      onClose={() => {}}
    >
      <DialogTitleWithClose
        title={
          <div className="flex items-center gap-x-2">
            <GlobeAltIcon className="size-6" />
            {assistantName}
          </div>
        }
        onClose={() => {
          room.disconnect();
          onClose();
        }}
      />

      <DialogBody className="flex items-center justify-center h-80">
        <LivekitWebCall
          room={room}
          onConnect={onConnect}
          onClose={() => {
            room.disconnect();
            onClose();
          }}
        />
      </DialogBody>
    </Dialog>
  );
}
